import { useHistory } from 'react-router-dom';
import { useCallback, useEffect, useRef, useState } from 'react';
import UserService from '../service/user.service';
import NavBar from './navbar';
import Footer from './footer';

const BACKEND_URL = process.env.REACT_APP_BACKEND_ROOT || 'https://wesdasdasda.online/escort_api/';

const SERVICE_FILTERS = [
    { key: '', label: 'Все' },
    { key: 'home', label: 'На дом' },
    { key: 'out', label: 'Выезд' },
    { key: 'night', label: 'Ночь' },
];

const PRICE_FILTERS = [
    { key: 0, label: 'Любая цена' },
    { key: 10000, label: 'до 10 000' },
    { key: 20000, label: 'до 20 000' },
    { key: 50000, label: 'до 50 000' },
];

export default function ModelsComponent({ user, region }) {
    const history = useHistory();
    const [models, setModels] = useState([]);
    const [page, setPage] = useState(1);
    const [hasMore, setHasMore] = useState(false);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [serviceFilter, setServiceFilter] = useState('');
    const [maxPrice, setMaxPrice] = useState(0);
    const currency = region === 'kz' ? 5 : 1;
    const debounceRef = useRef(null);
    const searchRef = useRef('');

    const fetchModels = useCallback((p, s, sf, mp) => {
        setLoading(true);
        UserService.getAllModels(user.id, p, 8, s, sf, mp)
            .then(response => {
                const { models: data, has_more } = response.data;
                setModels(data);
                setHasMore(has_more);
            })
            .catch(err => console.error(err))
            .finally(() => setLoading(false));
    }, [user.id]);

    useEffect(() => {
        fetchModels(1, search, serviceFilter, maxPrice);
    }, [serviceFilter, maxPrice]);

    function handleSearchChange(e) {
        const val = e.target.value;
        setSearch(val);
        searchRef.current = val;
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(() => {
            setPage(1);
            fetchModels(1, searchRef.current, serviceFilter, maxPrice);
        }, 400);
    }

    function applyServiceFilter(key) {
        setServiceFilter(key);
        setPage(1);
    }

    function applyPriceFilter(key) {
        setMaxPrice(key);
        setPage(1);
    }

    function goToPage(p) {
        setPage(p);
        fetchModels(p, search, serviceFilter, maxPrice);
        window.scrollTo(0, 0);
    }

    return (
        <>
            <NavBar text="Выбор модели" />
            <div className="models-page">
                <div className="search-bar">
                    <input
                        type="text"
                        placeholder="Поиск по имени или национальности..."
                        value={search}
                        onChange={handleSearchChange}
                    />
                    <div className="filter-chips">
                        {SERVICE_FILTERS.map(f => (
                            <div
                                key={f.key}
                                className={`chip${serviceFilter === f.key ? ' active' : ''}`}
                                onClick={() => applyServiceFilter(f.key)}
                            >
                                {f.label}
                            </div>
                        ))}
                        {PRICE_FILTERS.map(f => (
                            <div
                                key={f.key}
                                className={`chip${maxPrice === f.key ? ' active' : ''}`}
                                onClick={() => applyPriceFilter(f.key)}
                            >
                                {f.label}
                            </div>
                        ))}
                    </div>
                </div>

                {loading ? (
                    <div className="models-grid">
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} className="skeleton-card">
                                <div className="skeleton-img" />
                                <div className="skeleton-line wide" style={{ marginTop: 10 }} />
                                <div className="skeleton-line narrow" />
                                <div className="skeleton-line" style={{ marginBottom: 10 }} />
                            </div>
                        ))}
                    </div>
                ) : models.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--text-secondary)' }}>
                        Модели не найдены
                    </div>
                ) : (
                    <>
                        <div className="models-grid">
                            {models.map(m => (
                                <div key={m.id} className="model-card" onClick={() => history.push('/profile/' + m.id)}>
                                    <img
                                        src={`${BACKEND_URL}uploads/${m.image_url}`}
                                        alt={m.name}
                                        loading="lazy"
                                    />
                                    <div className="model-card-info">
                                        <div className="name">{m.name}</div>
                                        <div className="params">
                                            <span>{m.age} лет, {m.height} см</span>
                                            <span>{m.national}</span>
                                        </div>
                                        <div className="price">от {m.home_ehour * currency} ₽</div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="pagination-row">
                            <button onClick={() => goToPage(page - 1)} disabled={page <= 1}>← Назад</button>
                            <span style={{ display: 'flex', alignItems: 'center', color: 'var(--text-secondary)', fontSize: 14 }}>
                                стр. {page}
                            </span>
                            <button onClick={() => goToPage(page + 1)} disabled={!hasMore}>Далее →</button>
                        </div>
                    </>
                )}

                <Footer />
            </div>
        </>
    );
}
